import { FunctionComponent } from 'react'
import { Image as ImageProps } from './Image.types'
import './Image.scss'
import classNames from 'classnames'

export const Image: FunctionComponent<ImageProps> = ({
  attributes,
  className,
  alt = ''
}) => {
  const { url } = attributes
  return (
    <img
      className={classNames('core-ux-image', className)}
      src={url}
      alt={alt}
      data-testid="image"
    />
  )
}
